import { FlowComponent } from '../../flow.min.js';
import styles from './styles.js';
import { AuthLogic } from './logic.js';

// Importamos los formularios
import './login-form.js';
import './resend-verification-form.js';

const logo = new URL('../../_shared/qr-smart-menu-logo.avif', import.meta.url)

const template = FlowComponent.html`
    <div class="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div class="max-w-md w-full space-y-8 bg-white p-10 rounded-xl shadow-lg border border-gray-100">
            <div>
                <img class="mx-auto h-16 w-auto" src="${logo}" alt="QR Smart Menu">
                <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">
                    ${'title'}
                </h2>
                <p class="mt-2 text-center text-sm text-gray-600 mb-8">
                    ${'subtitle'}
                </p>
            </div>
            
            <div id="form-container">
                <slot></slot>
            </div>
        </div>
    </div>
`;

export class AuthLogin extends AuthLogic(FlowComponent) {
    #view = 'login';

    static get styles() { return styles; }
    static get template() { return template; }

    get view() { return this.#view; }
    set view(val) {
        if (this.#view === val) return;
        this.#view = val;
        this.#updateContent();
    }

    onMount() {
        super.onMount();
        this.#updateContent();
    }

    #updateContent() {
        // Limpiamos el Light DOM
        this.innerHTML = '';

        switch(this.#view) {
            case 'verifying':
                this.setAttribute('title', 'Verificando cuenta');
                this.setAttribute('subtitle', 'Por favor espera un momento...');
                this.innerHTML = '<div class="flex justify-center py-10"><flow-loader></flow-loader></div>';
                break;
            case 'resend-verification':
                this.setAttribute('title', 'Verificación necesaria');
                this.setAttribute('subtitle', 'Parece que hubo un problema');
                this.innerHTML = '<resend-verification-form></resend-verification-form>';
                break;
            default:
                this.setAttribute('title', 'Bienvenido de nuevo');
                this.setAttribute('subtitle', 'Ingresa a tu panel administrativo');
                this.innerHTML = '<login-form></login-form>';
        }
    }
}

customElements.define('auth-login', AuthLogin);
